var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-empty"},[_c('img',{staticClass:"widget-empty__icon",attrs:{"src":"/images/empty-reports.svg","alt":""}}),_c('span',{staticClass:"widget-empty__text"},[_vm._v(_vm._s(_vm.$t('analytics.widget-empty-text')))]),_c('span',{staticClass:"widget-empty__subtext"},[_vm._v(_vm._s(_vm.$t('analytics.widget-empty-subtext')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }